import {
	Module,
	PageModule,
	AjaxPageModule,
	ComponentsModule,
	ViewportModule
} from 'libs';
import gsap from 'gsap';

export class TransitionModule extends Module{
	constructor(bootstrap){
		super(bootstrap);

		this.dependencies.add(PageModule);
		this.dependencies.add(AjaxPageModule);
		this.dependencies.add(ComponentsModule);
		this.dependencies.add(ViewportModule);

		this.loader 		= document.getElementById('loader');
		this.interloader 	= document.getElementById('interloader');
		
	}
	
	get viewport() { return this.bootstrap.get(ViewportModule).viewport; }
	get pageModule() { return this.bootstrap.get(PageModule); };
	get ajaxPageModule() { return this.bootstrap.get(AjaxPageModule); };
	get components() { return this.bootstrap.get(ComponentsModule).components; };

	get previousComponent(){ return this.pageModule.previous ? this.components.get(this.pageModule.previous) : null }
	get currentComponent(){ return this.pageModule.current ? this.components.get(this.pageModule.current) : null }

	async before(){
		var t = gsap.timeline();
		this.pageModule.autoRemove = false;
		if(this.pageModule.current){
			let currentPage = this.pageModule.current;
			const top = document.scrollingElement.scrollTop;
			gsap.set(currentPage, {position:'fixed', top:-top, left:0, width:'100%'});
			gsap.set(document.scrollingElement, {scrollTop:0});
			
			t.addLabel('close',0);
			t.add(() => this.emit('close'),">");
			if(this.currentComponent && typeof this.currentComponent.close === "function") {
				t.add(this.currentComponent.close(), 'close');		
			}		
			t.add(() => {
				this.pageModule.removeElement(currentPage);			
			});
			
				
		}
		
	}

	async after(){		
		this.timeline = gsap.timeline();
		if(this.pageModule.previous){			
			this.timeline.addLabel('open','>');
			this.timeline.add(() => this.emit('open'), '>');	
			this.timeline.add(() => this.pageModule.current.style.removeProperty('visibility'), '>');
			if(this.currentComponent && typeof this.currentComponent.open === "function") this.timeline.add(this.currentComponent.open(),'open');

			
	
		}else{
			if(this.currentComponent && typeof this.currentComponent.open === "function") this.timeline.add(this.currentComponent.open(),0); 
		}
		

	}
}